import type { FaireProductEntity } from "../../entity_types/product";

export const p_eg4rqajj42: FaireProductEntity = {
  token: "p_eg4rqajj42",
  type: "product",
  name: "Jesus Is King Easter Basket",
  brandToken: "b_k5p875q9mb",
  brandName: "Holy Pals",
  imageUrl:
    "https://cdn.faire.com/fastly/3b69e3d966b3d18816c2bb7aa2492ae50e44c4b25f8e2689b0042c8ba43b2c74.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd5639832c2228663fa764353a74c1cd4c9a609089dcda4787259a62aef3d0e3.jpeg",
    "https://cdn.faire.com/fastly/74ad2d7fbcaf092b18750ef9dbdcc6decfdd27b94ff3949b0c38db5663a26d7a.jpeg",
    "https://cdn.faire.com/fastly/978ac12bf3e1499e102e3dc404355194c56c1207c0064b2c8abbc8b0ea2ab89d.jpeg",
    "https://cdn.faire.com/fastly/97272dc05f9109376d3b1a356b6f4796b7ab80d763c2fa146dd7156d23d775db.jpeg",
    "https://cdn.faire.com/fastly/61c7d9bf57c933d5e3229ea8847a17cdcaa731d157e207e416eb0447ade9b33b.jpeg",
    "https://cdn.faire.com/fastly/c2ed91ca335127218bd5ef43254b65254b6ac268e97b0a597a6160ed2d46de6e.jpeg",
    "https://cdn.faire.com/fastly/4cac5c63f908914e9df558d41e1ab4bf6942686c690c6e02958543df0c573d7e.jpeg",
  ],
  priceDollars: 14,
  description:
    "The Holy Pals Jesus Is King Easter Basket is more than just a basket; it's an opportunity for your child to grow closer to their faith. As with all our products, this basket is designed to bring the Bible to life. Perfect for Easter celebrations, it serves as a beautiful reminder of the Christian faith. It's not just about the goodies inside, but the stories and lessons that can be shared around it. Plus, with every purchase, you're supporting child-focused charities, making this Easter Basket an act of kindness.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:43.365Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
